<template>
    <div class="validate-item" :class="type">
        <div class="title">
            <div v-if="type === 'passed'" class="left-block label">通過</div>
            <div v-else-if="type === 'failure'" class="left-block label">未通過{{ data.length && ` (${data.length})` }}</div>
            <div class="right-block name">{{ label }}</div>
        </div>
        <div v-if="!isAuditFlowSetting && mappedData.length > 0" class="data-block">
            <div v-for="(item, index) in mappedData" :key="index" class="data-item">
                <div class="right-block data-item-content">
                    <span>{{ `${item.systemNumber}` }}</span>
                    <span>{{ `${item.name}` }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: '',
        },
        data: {
            type: [Array, Boolean],
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
    },
    computed: {
        mappedData() {
            if (this.isAuditFlowSetting) return this.data;

            return this.data.map((o) => {
                let systemNumber;
                let name;

                switch (Object.keys(o).join(',')) {
                case 'sno,poo,nam':
                    name = o.nam;
                    systemNumber = o.poo;
                    break;
                case 'sno,payoo,nam':
                    name = o.nam;
                    systemNumber = o.payoo;
                    break;
                case 'sno,ioo,description':
                    name = o.description;
                    systemNumber = o.ioo;
                    break;
                case 'sno,itemNam':
                    name = o.itemNam;
                    systemNumber = '---';
                    break;
                default:
                    return o;
                }
                return { systemNumber, name };
            });
        },
        isAuditFlowSetting() {
            return typeof this.data === 'boolean';
        },
    },
};
</script>

<style lang="scss" scoped>
.validate-item {
    border: 1px solid #ccc;
    border-radius: 6px;
    .title {
        display: flex;
        align-items: center;
        font-weight: bold;
        padding: 10px 20px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
    }
    .left-block {
        width: 90px;
    }
    .right-block {
        flex-grow: 1;
    }
    .data-block {
        padding: 10px 20px;
    }
    .data-item {
        display: flex;
    }
    .data-item-content > :first-child {
        margin-right: 15px;
    }

    &.passed {
        .title {
            background-color: #f0f9eb;
        }
        .label {
            color: #44bf00;
        }
    }
    &.failure {
        .title {
            background-color: #fef0f0;
        }
        .label {
            color: #ff0000;
        }
    }
}
</style>
